<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app",
};
</script>

<style lang="scss">
@font-face {
  font-family: PolySans;
  src: url(/font/PolySans-Neutral.woff), url(/font/PolySans-Neutral.woff2);
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-family: "PolySans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 10px;
  letter-spacing: -0.36px;
}
body {
  font-size: 1.4rem;
  line-height: 1;
}
h1 {
  margin: 0;
  font-size: 3.6rem;
  font-weight: 400;
  letter-spacing: -0.96px;
}
h2 {
  margin: 0;
  font-size: 3.6rem;
  font-weight: 400;
  letter-spacing: -0.8px;
}
#app {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
}
</style>